import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { ToastService, PluginService, RouteService } from '@kaiser-software/chassis-core';

import { LocationService } from '../../services/location.service';
import { LocationModel } from '../../models/location.model';

@Component({
    selector: 'donna-locations-show',
    templateUrl: 'show.page.html',
    styleUrls: ['show.page.scss']
})
export class LocationShowPage implements OnInit, OnDestroy {

    /**
     * The page title.
     *
     * @type {string}
     */
    protected title = 'Preview location';

    /**
     * The route prefix.
     */
    protected routePrefix = 'location';

    /**
     * The plugin slot prefix.
     *
     * @type {string}
     */
    protected pluginPrefix = 'donna-locations';

    /**
     * The LocationModel instance.
     *
     * @type {LocationModel}
     */
    public location: LocationModel = new LocationModel;

    /**
     * The LocationService instance.
     */
    protected locationService: LocationService;

    /**
     * The RouteService instance.
     */
    protected routeService: RouteService;

    /**
     * The ActivatedRoute instance.
     */
    protected activatedRoute: ActivatedRoute;

    /**
     * The PluginService instance.
     */
    protected pluginService: PluginService;

    /**
     * The ToastService instance.
     */
    protected ToastService: ToastService;

    /**
     * Constructor.
     *
     * @param {Injector} injector
     */
    constructor(protected injector: Injector) {
    }

    /**
     * OnInit.
     */
    public ngOnInit() {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.locationService.one(params['location']).subscribe((location: LocationModel) => {
                this.location = location;
            });
        }, (error) => {
            this.ToastService.error('error', error);
        });
    }

    /**
     * OnDestroy.
     */
    public ngOnDestroy() {
    }

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/locations/pages/show/show.page.ts